module.exports = __webpack_public_path__ + "img/arm-header-icons-hover-03.c6df1d97.svg";